import { defineMessages, type MessageDescriptor } from 'react-intl';

const messages: Partial<Record<string, MessageDescriptor>> = defineMessages({
  DK: {
    id: 'country.dk',
    defaultMessage: 'Denmark',
  },
  DE: {
    id: 'country.de',
    defaultMessage: 'Germany',
  },
  FR: {
    id: 'country.fr',
    defaultMessage: 'France',
  },
  NO: {
    id: 'country.no',
    defaultMessage: 'Norway',
  },
  CH: {
    id: 'country.ch',
    defaultMessage: 'Switzerland',
  },
  GB: {
    id: 'country.gb',
    defaultMessage: 'United Kingdom',
  },
  CA: {
    id: 'country.ca',
    defaultMessage: 'Canada',
  },
  NL: {
    id: 'country.nl',
    defaultMessage: 'Netherlands',
  },
  BE: {
    id: 'country.be',
    defaultMessage: 'Belgium',
  },
  ES: {
    id: 'country.es',
    defaultMessage: 'Spain',
  },
  IT: {
    id: 'country.it',
    defaultMessage: 'Italy',
  },
  PL: {
    id: 'country.pl',
    defaultMessage: 'Poland',
  },
  AT: {
    id: 'country.at',
    defaultMessage: 'Austria',
  },
  PT: {
    id: 'country.pt',
    defaultMessage: 'Portugal',
  },
  SE: {
    id: 'country.se',
    defaultMessage: 'Sweden',
  },
  US: {
    id: 'country.us',
    defaultMessage: 'United States',
  },
  IE: {
    id: 'country.ie',
    defaultMessage: 'Ireland',
  },
  CZ: {
    id: 'country.cz',
    defaultMessage: 'Czechia',
  },
  AU: {
    id: 'country.au',
    defaultMessage: 'Australia',
  },
  NZ: {
    id: 'country.nz',
    defaultMessage: 'New Zealand',
  },
  JP: {
    id: 'country.jp',
    defaultMessage: 'Japan',
  },
});

export default messages;
